<template>
  <div class="main">
    <div class="sidebar" :style="{ width: show ? '240px' : '0px' }">
      <div class="logo">
        <div class="logo_bg">
          <img src="../assets/logo.png" width="50" height="50" />
          <!-- LOGO -->
        </div>
      </div>
      <el-menu class="el_menus" :default-active="active" router background-color="#1F2E54" active-text-color="#fff" text-color="#fff" unique-opened :collapse="isCollapse">
        <div v-for="(item1, index1) in menuList" :key="index1">
          <!-- 一级菜单（没有子级菜单） -->
          <el-menu-item :index="item1.menuPath" v-if="item1.children.length == 0">
            <span class="menuname">{{ item1.menuName }}</span>
          </el-menu-item>
          <!-- 一级菜单（有子菜单） -->
          <el-submenu :index="item1.menuPath" v-else>
            <template slot="title">
              <span class="menuname">{{ item1.menuName }}</span>
            </template>
            <!-- 遍历二级菜单 -->
            <div v-for="(item2, index2) in item1.children" :key="index2">
              <!-- 二级菜单（没有三级菜单） -->
              <el-menu-item :index="item2.menuPath" v-if="item2.children.length == 0">
                <span class="menuname">{{ item2.menuName }}</span>
              </el-menu-item>
              <!-- 二级菜单（有三级菜单） -->
              <el-submenu :index="item2.menuPath" v-else>
                <template slot="title">
                  <span class="menuname">{{ item2.menuName }}</span>
                </template>
                <el-menu-item v-for="(item3, index3) in item2.children" :key="index3" :index="item3.menuPath">
                  <span slot="title" class="menuname">{{ item3.menuName }}</span>
                </el-menu-item>
              </el-submenu>
            </div>
          </el-submenu>
        </div>
      </el-menu>
    </div>

    <div class="container" :class="show ? 'container_ml' : 'container_all'">
      <div class="head">
        <navbar :list="breadcrumbs" :show="show" :collapse="isCollapse" @change="hideMenu" @personal="showPersonal" />
      </div>
      <div class="views">
        <transition mode="out-in" appear>
          <router-view />
        </transition>
      </div>
    </div>

    <div class="service" @click="contactService">
      <div>客服消息</div>
      <!-- <div class="msgtotal" v-if="msgtotal > 0">{{ msgtotal > 99 ? "99+" : msgtotal }}</div> -->
    </div>
  </div>
</template>

<script>
import navbar from "../components/navbar"

export default {
  components: { navbar },
  data() {
    return {
      active: "/",
      menuList: [],
      breadcrumbs: [],
      isCollapse: false,
      show: true,
    }
  },
  created() {
    this.menuList = this.$store.state.menuList
    this.initActive()
    this.setBreadcrumbs()
  },
  mounted() {
    window.addEventListener("resize", this.resizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeHandler)
  },
  watch: {
    $route() {
      this.initActive()
      this.setBreadcrumbs()
    },
  },
  methods: {
    // 初始化激活菜单
    initActive() {
      if (this.$route.path == "/") {
        this.active = this.menuList[0].children[0].menuPath
        this.$router.replace(this.active)
      } else {
        if (!this.$route.path.includes("/detail/")) {
          this.active = this.$route.path
        }
      }
    },
    // 设置面包屑
    setBreadcrumbs() {
      this.breadcrumbs = this.$route.matched.map(item => {
        let obj = {
          name: item.meta.title,
          path: item.path,
        }
        return obj
      })
    },
    // 监听窗口大小，显隐侧边栏
    resizeHandler() {
      if (window.innerWidth < 1280) {
        this.show = false
        this.isCollapse = true
      } else {
        this.show = true
        this.isCollapse = false
      }
    },
    // 显隐侧边栏
    hideMenu() {
      this.$nextTick(() => {
        this.isCollapse = !this.isCollapse
        this.show = !this.show
      })
    },
    showPersonal() {
      // this.$router.push('/personals');
      // this.active = ''
    },
    // 打开聊天室
    contactService() {
      if (process.env.NODE_ENV === "production") {
        window.open(`https://ycf.chat.ganmiaoedu.com/#/systems?type=${5}`) //type类型：1供应商；2商超；3骑手；4商城；5总后台
      } else {
        window.open(`http://192.168.2.6:8080/#/systems?type=${5}`) //type类型：1供应商；2商超；3骑手；4商城；5总后台
      }
    },
  },
}
</script>

<style scoped lang="scss">
.main {
  width: 100%;
  height: 100%;

  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 240px;
    height: 100%;
    background-color: #1f2e54;
    overflow: auto;
    transition: all 0.3s ease-in-out;

    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }

    .logo {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 80px;
      user-select: none;

      .logo_bg {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60px;
        height: 60px;
        font-weight: bold;
        border-radius: 10px;
        background-color: #fff;
      }
    }

    .el_menus {
      width: 100%;
      border: none !important;

      .menuname {
        font-size: 15px;
      }

      .childbg {
        background-color: #101c40 !important;
      }

      // 已激活的菜单背景色
      .el-submenu {
        ::v-deep .el-menu,
        ::v-deep .el-menu-item {
          background: #0a183c !important;
        }
      }
      .is-opened {
        ::v-deep .el-submenu__title {
          background: #0a183c !important;
        }
      }

      ::v-deep .el-submenu__title i {
        color: #fff;
      }

      .el-menu-item.is-active {
        background-color: $themes !important;
      }

      ::v-deep .el-submenu__title:hover,
      ::v-deep .el-menu-item:hover {
        background: rgba(23, 119, 217, 0.5) !important;
      }
    }

    .fold {
      color: #fff;
      text-align: center;
    }
  }

  .container {
    display: flex;
    flex-direction: column;
  }

  .container_ml {
    margin-left: 240px;
    transition: all 0.3s ease-in-out;
  }

  .container_all {
    margin-left: 0;
    transition: all 0.3s ease-in-out;
  }

  .views {
    height: 100%;
    min-height: calc(100vh - 2px - 80px - 70px);
    padding: 20px;
    margin: 20px;
    border-radius: 10px;
    border: 1px solid #e2e2e2;
    background-color: #fff;
  }

  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.3s;
  }

  .v-enter,
  .v-leave-to {
    opacity: 0;
  }

  .service {
    position: fixed;
    right: 0;
    bottom: 10px;
    width: 15px;
    color: #fff;
    font-size: 12px;
    padding: 12px 6px 12px 10px;
    background-color: $themes;
    border-radius: 10px 0 0 10px;
    z-index: 9999;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
    .msgtotal {
      position: absolute;
      top: -8px;
      right: -8px;
      width: fit-content;
      background-color: #f56c6c;
      padding: 2px 6px;
      border-radius: 50px;
    }
  }
}
</style>
